import { Box, Grid, GridProps } from '@mui/material';

export type SectionedGridContainerProps = Omit<
  GridProps,
  'container' | 'spacing' | 'rowSpacing' | 'columnSpacing'
>;

export function SectionedGridContainer(props: SectionedGridContainerProps) {
  return (
    <Box sx={{ mx: 4, my: 3 }}>
      <Grid container rowSpacing={3} columnSpacing={4} {...props} />
    </Box>
  );
}
